var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 80,
    viewBox: "0 0 320 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16, 16) scale(0.2857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 84,
    r: 84,
    fill: "#2A4459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6629 104.388L37.916 121.95V48.9102L67.6629 66.6228V104.388Z",
    fill: "#39B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.179 105.217L107.432 122.772V49.7324L137.179 67.4519V105.217Z",
    fill: "#39B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.904 46.913L102.013 81.4558L38.9961 44.5253L69.3177 27.8184L101.904 46.913Z",
    fill: "#FFDE59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6609 144.001L38.9688 126.35L103.033 91.2598L101.788 125.857L68.6609 144.001Z",
    fill: "#FFDE59"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 40,
    dominantBaseline: "central",
    fontFamily: "Avenir, -apple-system, Segoe UI, Helvetica, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 34,
    fill: "#2A4459"
  }, "CashAfrica")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.92cf9b6508af1dd0a8ffddcfe74954ac.svg";
export { ForwardRef as ReactComponent };